import _ from 'underscore';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';

export const ESTIMATE_TYPES = {
  IMPRESSION_SHARE: 'imprShare',
  IMPRESSIONS: 'impressions',
  QUERY_VOLUME: 'queryVolume',
  COST: 'cost',
  CLICKS: 'clicks',
  CTR: 'ctr',
  CONVERSIONS: 'conv',
  WEEKLY_SEARCHES: 'weeklySearches',
  REJECTED_ADS: 'rejectedAds',
  REJECTED_KEYWORDS: 'rejectedKeywords',
  MISSING_CONVERSIONS: 'missingConv',
  TARGETED_PRODUCTS: 'targetedProducts',
};

export const NO_SYMBOL_ESTIMATE_TYPES = [
  ESTIMATE_TYPES.REJECTED_ADS,
  ESTIMATE_TYPES.REJECTED_KEYWORDS,
  ESTIMATE_TYPES.MISSING_CONVERSIONS,
];

export const SUMMARY_CARD = 'SummaryCard';
export const RECOMMENDATIOIN_SUMMARY_APPLY_FAILED_RESULTS = 'RecommendationSummaryPageApplyFaildResult';

export const RECOMMENDATION_TYPES = {
  BUDGET: 'CompetitiveBudgetOpportunity',
  COMPETITIVE_BID: 'CompetitiveBidOpportunity',
  DEVICE_BID_BOOST: 'CompetitiveDeviceBidBoostOpportunity',
  LOCATION_BID_BOOST: 'CompetitiveLocationBidBoostOpportunity',
  NEW_KEYWORD: 'CompetitiveKeywordOpportunity', // deprecated in Oct 2023
  BROAD_MATCH_KEYWORD: 'BroadMatchAdoptionOpportunity',
  BUDGET_OPPORTUNITY: 'BudgetOpportunity',
  ADJUST_SHARED_BUDGET_OPPORTUNITY: 'AdjustSharedBudgetOpportunity',
  CALLOUT: 'CalloutOpportunity',
  GOOGLE_IMPORT: 'GoogleImportOpportunity',
  GOOGLE_IMPORT_SCHEDULED: 'GoogleImportScheduledOpportunity',
  NEW_KEYWORD_OPPORTUNITY: 'CampaignContextKeywordOpportunity',
  TRENDING_QUERY: 'RisingQueryKeywordOpportunity',
  REPAIR_ADS: 'RepairAdsOpportunity',
  REPAIR_KEYWORD: 'RepairKeywordsOpportunity',
  SITE_LINK: 'SiteLinkOpportunity',
  REMOVE_CONFLICTING_NEGATIVE_KEYWORD: 'RemoveConflictingNegativeKeywordOpportunity',
  RESPONSIVE_SEARCH_ADS: 'ResponsiveSearchAdsOpportunity',
  DYNAMIC_SEARCH_ADS: 'DSAOpportunity',
  REALLOCATE_BUDGET: 'ReallocateBudgetOpportunity',
  FIX_AD_TEXT: 'FixAdContentOpportunity',
  FIX_AD_DESTINATION: 'FixAdDestinationOpportunity',
  SETUP_CONVERSION_TRACKING_OPPORTUNITY: 'SetupConversionTrackingOpportunity',
  FIX_CONVERSION_TRACKING_OPPORTUNITY: 'FixConversionTrackingOpportunity',
  FIX_CONVERSION_GOAL_SETTINGS: 'FixConversionGoalSettingsOpportunity',
  MULTIMEDIA_ADS: 'MultiMediaAdsOpportunity',
  CREATE_CONVERSION_GOAL: 'CreateConversionGoalOpportunity',
  FACEBOOK_IMPORT: 'FacebookImportOpportunity',
  IMAGE_EXTENSION: 'ImageExtensionOpportunity',
  REPAIR_MISSING_KEYWORD_PARAMS: 'RepairMissingKeywordParamsOpportunity',
  FIX_NO_IMPRESSION_BID: 'FixNoImpressionBidOpportunity',
  IMPROVE_RESPONSIVE_SEARCH_ADS: 'ImproveResponsiveSearchAdsOpportunity',
  REPAIR_UNTARGETED_OFFER: 'RepairUntargetedOfferOpportunity',
  IMPROVE_MULTIMEDIA_ADS: 'ImproveMultiMediaAdsOpportunity',
  SSC_2_PMAX_MIGRATION: 'SSC2PMaxMigrationOpportunity',
  PMAX_IMPORT: 'PerformanceMaxImportOpportunity',
  DSA_2_PMAX_MIGRATION: 'DSA2PMaxMigrationOpportunity',
  SYNDICATION_GAP: 'SyndicationGapOpportunity',
  AUDIENCE_VIDEOASSET: 'VideoRecommendationForAudienceCampaignOpportunity',
};

export const BUDGET_OPPORTUNITY_TYPES = [
  RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY,
];

export const RECOMMENDATION_IDS = {
  [RECOMMENDATION_TYPES.BUDGET]: '40001',
  [RECOMMENDATION_TYPES.COMPETITIVE_BID]: '19',
  [RECOMMENDATION_TYPES.DEVICE_BID_BOOST]: '211',
  [RECOMMENDATION_TYPES.LOCATION_BID_BOOST]: '212',
  [RECOMMENDATION_TYPES.NEW_KEYWORD]: '32001', // deprecated in Oct 2023
  [RECOMMENDATION_TYPES.NEW_LOCATION]: '213',
  [RECOMMENDATION_TYPES.SYNDICATION]: '214',
  [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: '202',
  [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: '40',
  [RECOMMENDATION_TYPES.CALLOUT]: '132',
  [RECOMMENDATION_TYPES.GOOGLE_IMPORT]: '205',
  [RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED]: '206',
  [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: '32',
  [RECOMMENDATION_TYPES.TRENDING_QUERY]: '237',
  [RECOMMENDATION_TYPES.REPAIR_ADS]: '60',
  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: '61',
  [RECOMMENDATION_TYPES.SITE_LINK]: '131',
  [RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD]: '36',
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: '228',
  [RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS]: '210',
  [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: '42',
  [RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY]: '40002',
  [RECOMMENDATION_TYPES.FIX_AD_TEXT]: '62001',
  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: '62002',
  [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]: '65',
  [RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY]: '66',
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: '90',
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: '242',
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: '91',
  [RECOMMENDATION_TYPES.FACEBOOK_IMPORT]: '247',
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: '223',
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: '251',
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: '21',
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: '73',
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: '68',
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: '74',
  [RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION]: '44',
  [RECOMMENDATION_TYPES.PMAX_IMPORT]: '268',
  [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: '270',
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: '221',
  [RECOMMENDATION_TYPES.AUDIENCE_VIDEOASSET]: '277',
};

export const ESTIMATE_STRINGS = {
  [ESTIMATE_TYPES.CLICKS]: 'Summary_Card_Estimate_Clicks',
  [ESTIMATE_TYPES.COST]: 'Summary_Card_Estimate_Cost',
  [ESTIMATE_TYPES.IMPRESSION_SHARE]: 'Summary_Card_Estimate_Impression_Share',
  [ESTIMATE_TYPES.IMPRESSIONS]: 'Summary_Card_Estimate_Impressions',
  [ESTIMATE_TYPES.QUERY_VOLUME]: 'Summary_Card_Estimate_Query_Volume',
  [ESTIMATE_TYPES.CTR]: 'Summary_Card_Estimate_CTR',
  [ESTIMATE_TYPES.CONVERSIONS]: 'Summary_Card_Estimate_Conversions',
  [ESTIMATE_TYPES.WEEKLY_SEARCHES]: 'Summary_Card_Estimate_Weekly_Searches',
  [ESTIMATE_TYPES.REJECTED_ADS]: 'Summary_Card_Estimate_Rejected_Ads',
  [ESTIMATE_TYPES.REJECTED_KEYWORDS]: 'Summary_Card_Estimate_Rejected_Keywords',
  [ESTIMATE_TYPES.MISSING_CONVERSIONS]: 'Summary_Card_Estimate_Missing_Conversions',
  [ESTIMATE_TYPES.TARGETED_PRODUCTS]: 'Summary_Card_Estimate_Targeted_Products',
};

export const SUMMARY_LEVELS = levelAtConstant;

export const VISUAL_TYPES = {
  SEARCH_TERMS_CHART: 'Search_Terms_Chart',
  COLUMN_CHART: 'Column_Chart',
  LINE_CHART: 'Line_Chart',
  LINE_WEEKLY_CHART: 'Line_Weekly_Chart',
  LINE_COLUMN_CHART: 'Line_Column_Chart',
  TABLE: 'Table',
  MAP: 'Map',
  ADS_PREVIEW: 'Ads_Preview',
};

export const VISUAL_TABLE_ENABLED_SCOPES = {
  ACCOUNT: [
    levelAtConstant.CUSTOMER,
    levelAtConstant.ACCOUNT,
  ],
  CAMPAIGN: [
    levelAtConstant.CUSTOMER,
    levelAtConstant.ACCOUNT,
    levelAtConstant.CAMPAIGN,
  ],
  ADGROUP: [
    levelAtConstant.CUSTOMER,
    levelAtConstant.ACCOUNT,
    levelAtConstant.CAMPAIGN,
    levelAtConstant.ADGROUP,
  ],
};

export const CHANNEL_TYPES = {
  COMPETITION: 'competitionpage',
  RECOMMENDATION: 'recommendationpage',
  INCONTEXT: 'incontextrecommendation',
  INCONTEXTCARD: 'incontextcard',
  OVERVIEW: 'overviewpage',
  MCCRECOMMENDATION: 'mccrecommendationpage',
  MCCOVERVIEW: 'mccoverviewpage',
  AUTO_APPLY_REC_SETTING: 'autoApplyRecdSettingUpdate',
  CAMPAIGN_SUMMARY_BAR: 'campaignsummarybar',
  SEARCHINSIGHT: 'searchinsight',
};

const RECOMMENDATIONS = [
  RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD,
  RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.CALLOUT,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED,
  RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY,
  RECOMMENDATION_TYPES.TRENDING_QUERY,
  RECOMMENDATION_TYPES.REPAIR_ADS,
  RECOMMENDATION_TYPES.REPAIR_KEYWORD,
  RECOMMENDATION_TYPES.SITE_LINK,
  RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD,
  RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS,
  RECOMMENDATION_TYPES.REALLOCATE_BUDGET,
  RECOMMENDATION_TYPES.FIX_AD_DESTINATION,
  RECOMMENDATION_TYPES.FIX_AD_TEXT,
  RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
  RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
  RECOMMENDATION_TYPES.FACEBOOK_IMPORT,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.IMAGE_EXTENSION,
  RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS,
  RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID,
  RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER,
  RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.PMAX_IMPORT,
  RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.SYNDICATION_GAP,
  RECOMMENDATION_TYPES.AUDIENCE_VIDEOASSET,
];

export const CHANNEL_ALL_RECOMMENDATIONS = {
  [CHANNEL_TYPES.COMPETITION]: [
    RECOMMENDATION_TYPES.BUDGET,
    RECOMMENDATION_TYPES.COMPETITIVE_BID,
    RECOMMENDATION_TYPES.DEVICE_BID_BOOST,
    RECOMMENDATION_TYPES.LOCATION_BID_BOOST,
  ],
  [CHANNEL_TYPES.RECOMMENDATION]: RECOMMENDATIONS,
  [CHANNEL_TYPES.MCCRECOMMENDATION]: RECOMMENDATIONS,
  [CHANNEL_TYPES.MCCOVERVIEW]: RECOMMENDATIONS,
  [CHANNEL_TYPES.OVERVIEW]: RECOMMENDATIONS,
  [CHANNEL_TYPES.CAMPAIGN_SUMMARY_BAR]: RECOMMENDATIONS,
  [CHANNEL_TYPES.SEARCHINSIGHT]: RECOMMENDATIONS,
  [CHANNEL_TYPES.INCONTEXT]: [
    RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY,
  ],
  [CHANNEL_TYPES.INCONTEXTCARD]: [
    RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY,
    RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
    RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY,
    RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
    RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY,
    RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
    RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
    RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY,
    RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
    RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS,
    RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID,
    RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS,
    RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER,
    RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
    RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION,
    RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION,
    RECOMMENDATION_TYPES.SYNDICATION_GAP,
  ],
};

export const NOT_SUPPORT_DOWNLOAD_TYPES = [
  RECOMMENDATION_TYPES.GOOGLE_IMPORT,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED,
  RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
  RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
  RECOMMENDATION_TYPES.FACEBOOK_IMPORT,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.IMAGE_EXTENSION,
  RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS,
  RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.PMAX_IMPORT,
  RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.SYNDICATION_GAP,
  RECOMMENDATION_TYPES.AUDIENCE_VIDEOASSET,
];

export const NOT_SUPPORT_DISMISS_TYPES = [
  RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION,
];

export const APPLY_ODATA_TYPES = {
  APPLY_BULK_OPPORTUNITY_REQUEST: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBulkOpportunitiesRequest',
  APPLY_ALL_OPPORTUNITY_REQUEST: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyAllOpportunitiesRequest',
  APPLY_BULK_RECOMMENDATION_REQUEST: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBulkAccountRecommendationRequest',
  APPLY_ALL_RECOMMENDATION_REQUEST: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyAllAccountRecommendationRequest',
  APPLY_BULK_RECOMMENDATION_REQUEST_MCC: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBulkMccRecommendationRequest',
  APPLY_ALL_RECOMMENDATION_REQUEST_MCC: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyAllMccRecommendationRequest',
};

export const APPLY_ODATA_TYPES_MAP = {
  ALL: {
    MCC: APPLY_ODATA_TYPES.APPLY_ALL_RECOMMENDATION_REQUEST_MCC,
    SINGLE_ACCOUNT: APPLY_ODATA_TYPES.APPLY_ALL_OPPORTUNITY_REQUEST,
    SINGLE_ACCOUNT_ASYNC: APPLY_ODATA_TYPES.APPLY_ALL_RECOMMENDATION_REQUEST,
    OPTIMIZATION_SCORE: APPLY_ODATA_TYPES.APPLY_ALL_RECOMMENDATION_REQUEST,
  },
  BULK: {
    MCC: APPLY_ODATA_TYPES.APPLY_BULK_RECOMMENDATION_REQUEST_MCC,
    SINGLE_ACCOUNT: APPLY_ODATA_TYPES.APPLY_BULK_OPPORTUNITY_REQUEST,
    SINGLE_ACCOUNT_ASYNC: APPLY_ODATA_TYPES.APPLY_BULK_RECOMMENDATION_REQUEST,
    OPTIMIZATION_SCORE: APPLY_ODATA_TYPES.APPLY_BULK_RECOMMENDATION_REQUEST,
  },
};

export const APPLY_USERINPUT_TYPES = {
  [RECOMMENDATION_TYPES.BUDGET]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBudgetOpportunityUserInputV2',
  [RECOMMENDATION_TYPES.COMPETITIVE_BID]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBidOpportunityUserInput',
  [RECOMMENDATION_TYPES.DEVICE_BID_BOOST]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyCompetitiveBidBoostOpportunityUserInput',
  [RECOMMENDATION_TYPES.LOCATION_BID_BOOST]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyCompetitiveBidBoostOpportunityUserInput',
  [RECOMMENDATION_TYPES.NEW_KEYWORD]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyKeywordOpportunityUserInput', // deprecated in Oct 2023
  [RECOMMENDATION_TYPES.REPAIR_ADS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyRepairAdsOpportunityUserInput',
  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyRepairKeywordsOpportunityUserInput',
  [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBroadMatchAdoptionOpportunityUserInput',
  [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyKeywordOpportunityUserInput',
  [RECOMMENDATION_TYPES.TRENDING_QUERY]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyKeywordOpportunityUserInput',
  [RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyUserInput',
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyResponsiveSearchAdsOpportunityUserInput',
  [RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyDSAOpportunityUserInput',
  [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyReallocateBudgetOpportunityUserInput',
  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyFixAdDestinationOpportunityUserInput',
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyFixConversionGoalSettingsOpportunityUserInput',
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyCreateConversionGoalOpportunityUserInput',
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyMultiMediaAdsOpportunityUserInput',
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyImageExtensionOpportunityUserInput',
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyRepairMissingKeywordParamsOpportunityUserInput',
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBidOpportunityUserInput',
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyImproveResponsiveSearchAdsOpportunityUserInput',
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyRepairUntargetedOfferOpportunityUserInput',
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyImproveMultiMediaAdsOpportunityUserInput',
  [RECOMMENDATION_TYPES.AUDIENCE_VIDEOASSET]: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyVideoRecommendationOpportunityUserInput',
};
APPLY_USERINPUT_TYPES[[RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]]
  = APPLY_USERINPUT_TYPES[[RECOMMENDATION_TYPES.BUDGET]];
APPLY_USERINPUT_TYPES[[RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY]]
  = APPLY_USERINPUT_TYPES[[RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]];

export const APPLY_ACTION_TYPES = {
  ACCEPT: 'Accept',
  DISMISS: 'Dismiss',
  REJECT: 'Reject',
  REDISMISS: 'Redismiss',
  UNDISMISS: 'Undismiss',
};

export const SETTING_OPTIONS = {
  UPDATE_FROM_CAMPAIGN: 'UpdateRecommendationFromCampaignDb',
  REJECTION_DATE_LAST_NINETY_DAYS: 'RejectionDateFilterLast90Days',
  NONE: 'None',
};

export const COMPETITION_RECOMMENDATION_FEATURE_NAME = 'CompetitionRecommendation';

export const COMPETITION_RECOMMENDATION_PREFERENCES = 'WebApp.CampaignUI.CompetitionRecommendationPreferences';
export const RECOMMENDATION_PREFERENCES = 'WebApp.CampaignUI.RecommendationPreferences';

export const COMPETITION_RECOMMENDATION_PAGE_SIZES = [3, 10, 20, 50];
export const RECOMMENDATION_PAGE_SIZES = [20, 50, 100];
export const RECOMMENDATION_IMAGE_EXTENSION_PAGE_SIZES = [5];
export const RECOMMENDATION_IMAGE_EXTENSION_PAGE_SIZES_TEN = [10];
export const RECOMMENDATION_IMAGE_EXTENSION_PAGE_SIZES_TWENTY = [20];

export const COMPETITION_DEFAULT_PAGE_SIZE = COMPETITION_RECOMMENDATION_PAGE_SIZES[0];
export const RECOMMENDATION_DEFAULT_PAGE_SIZE = RECOMMENDATION_PAGE_SIZES[0];

export const APPLY_SETTINGS = {
  DEFAULT: '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplySettings',
};

export const MAX_NUMBER_OF_RECOMMENDATION_SAMPLES = 4;

export const MAX_NUMBER_OF_RECOMMENDATION_SAMPLES_WITH_OS = 2;

export const MATCH_TYPE_IDS = {
  EXACT: 1,
  PHRASE: 2,
  BROAD: 3,
};

export const MATCH_TYPE = {
  EXACT: 'Exact',
  PHRASE: 'Phrase',
  BROAD: 'Broad',
};

export const PERIOD_TYPE = {
  WORKDAY: 1,
  WEEKEND: 2,
};

export const MAP_HEIGHT = '320px';

export const ADINSIGHT_LOG_API_NAME = {
  COMPETITION: 'competitionpage',
  RECOMMENDATION: 'recommendationpage',
  INCONTEXTCARD: 'incontextcard',
  SEARCHINSIGHT: 'searchinsight',
};

export const ADINSIGHT_LOG_ACTION_TYPE = {
  VIEW: 'View',
  VIEWEDIT: 'ViewEdit',
  CUSTOM: 'Custom',
  CLICK_CATEGORY: 'Click',
  CLICK_RECS: 'ClickRecs',
  CLICK_APPLYALL: 'ClickApplyAll',
  IMPRESSION: 'Impression',
  FEEDBACK: 'Feedback',
  DOWNLOAD: 'Export',
  HIDE: 'Hide',
  VIEW_EXTERNAL: 'ViewExternal',
  CLICK_DISMISSALL: 'ClickDismissAll',
  REDIRECT: 'Redirect',
};

export const SUMMARY_APPLY_ALL_ENABLED = {
  [RECOMMENDATION_TYPES.BUDGET]: true,
  [RECOMMENDATION_TYPES.COMPETITIVE_BID]: true,
  [RECOMMENDATION_TYPES.DEVICE_BID_BOOST]: true,
  [RECOMMENDATION_TYPES.LOCATION_BID_BOOST]: true,
  [RECOMMENDATION_TYPES.NEW_LOCATION]: false,
  [RECOMMENDATION_TYPES.SYNDICATION]: false,
  [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: true,
  [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: true,
  [RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY]: true,
  [RECOMMENDATION_TYPES.CALLOUT]: false,
  [RECOMMENDATION_TYPES.GOOGLE_IMPORT]: false,
  [RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED]: false,
  [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: true,
  [RECOMMENDATION_TYPES.TRENDING_QUERY]: true,
  [RECOMMENDATION_TYPES.REPAIR_ADS]: false,
  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: false,
  [RECOMMENDATION_TYPES.SITE_LINK]: false,
  [RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD]: true,
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: true,
  [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: true,
  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: false,
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: false,
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: false,
  [RECOMMENDATION_TYPES.FACEBOOK_IMPORT]: false,
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: true,
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: false,
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: true,
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: true,
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: true,
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: true,
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: true,
  [RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION]: true,
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: true,
  [RECOMMENDATION_TYPES.AUDIENCE_VIDEOASSET]: true,
};

// import center's recommendations, only import types
export const IMPORTCENTER_RECOMMENDATION_TYPES = [
  RECOMMENDATION_TYPES.GOOGLE_IMPORT,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED,
  RECOMMENDATION_TYPES.FACEBOOK_IMPORT,
];

export const RECOMMENDATION_CATEGORIES = {
  ALL: 'All',
  REPAIRS: 'Repairs',
  BIDS: 'Bids',
  KEYWORDS: 'Keywords',
  ADS: 'Ads',
  DISMISSED: 'Dismissed',
};

export const RECOMMENDATION_CATEGORIES_IDS = {
  [RECOMMENDATION_CATEGORIES.ALL]: 'All Recommendations',
  [RECOMMENDATION_CATEGORIES.REPAIRS]: 'Repairs',
  [RECOMMENDATION_CATEGORIES.BIDS]: 'Bids & Budgets',
  [RECOMMENDATION_CATEGORIES.KEYWORDS]: 'Keywords & Targeting',
  [RECOMMENDATION_CATEGORIES.ADS]: 'Ads & Extensions',
  [RECOMMENDATION_CATEGORIES.DISMISSED]: 'Dismissed',
};

export const RECOMMENDATION_CATEGORIES_WORDING = {
  [RECOMMENDATION_CATEGORIES_IDS[RECOMMENDATION_CATEGORIES.ALL]]: 'All Recommendations',
  [RECOMMENDATION_CATEGORIES_IDS[RECOMMENDATION_CATEGORIES.REPAIRS]]: 'Repairs',
  [RECOMMENDATION_CATEGORIES_IDS[RECOMMENDATION_CATEGORIES.BIDS]]: 'Bidding & budgets',
  [RECOMMENDATION_CATEGORIES_IDS[RECOMMENDATION_CATEGORIES.KEYWORDS]]: 'Keywords & targeting',
  [RECOMMENDATION_CATEGORIES_IDS[RECOMMENDATION_CATEGORIES.ADS]]: 'Ads & Extensions',
  [RECOMMENDATION_CATEGORIES_IDS[RECOMMENDATION_CATEGORIES.DISMISSED]]: 'Dismissed',
};

export const RECOMMENDATION_CATEGORIES_STRINGS = {
  [RECOMMENDATION_CATEGORIES.ALL]: 'Recommendations_Category_All',
  [RECOMMENDATION_CATEGORIES.REPAIRS]: 'Recommendations_Category_Repairs',
  [RECOMMENDATION_CATEGORIES.BIDS]: 'Recommendations_Category_Bids',
  [RECOMMENDATION_CATEGORIES.KEYWORDS]: 'Recommendations_Category_Target',
  [RECOMMENDATION_CATEGORIES.ADS]: 'Recommendations_Category_Ads',
};

export const SEASONAL_TRACKID = 8;

export const NOT_AVAILABLE_DEFAULT_STR = '-';

export const CONVERSION_STATUS_TYPE = {
  NO_UET: 0,
  NO_DATA: 1,
  HAS_DATA: 2,
};

export const RECOMMENDATION_DISMISS_FEEDBACK_TYPE = {
  [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: true,
  [RECOMMENDATION_TYPES.TRENDING_QUERY]: true,
  [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: true,
  [RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD]: true,
  [RECOMMENDATION_TYPES.REPAIR_ADS]: true,
  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: true,
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: true,
  [RECOMMENDATION_TYPES.FIX_AD_TEXT]: true,
  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: true,
  [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]: true,
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: true,
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: true,
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: true,
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: true,
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: true,
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: true,
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: true,
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: true,
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: true,
  [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: true,
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: true,
};

export const RECOMMENDATION_NOTIFICATION_ERRORCODE = {
  Recommendation_Error_53505: {
    hasLearnMore: true,
    helpId: 'help:ext53097',
  }, // Recommendation_Error_MaxKeywordsLimitExceededForAdGroup
  Recommendation_Error_53504: {
    hasLearnMore: true,
    helpId: 'help:ext51042',
  }, // Recommendation_Error_MaxKeywordsLimitExceededForAccount
  Recommendation_Error_53521: {
    hasLearnMore: true,
    helpId: 'help:ext53092',
  }, // Recommendation_Error_KeywordBroadBidAmountsLessThanFloorPrice
  Recommendation_Error_53517: {
    hasLearnMore: true,
    helpId: 'help:ext53092',
  }, // Recommendation_Error_KeywordBroadBidAmountsGreaterThanCeilingPrice
  Recommendation_Error_53508: {
    hasLearnMore: false,
    helpId: null,
  }, // Recommendation_Error_Keyword_KeywordNotFound
  Recommendation_Error_53507: {
    hasLearnMore: false,
    helpId: null,
  }, // Recommendation_Error_Keyword_KeywordNotFound
  Recommendation_Error_52505: {
    hasLearnMore: true,
    helpId: 'help:ext53094',
  }, // Recommendation_Error_Keyword_AdGroupInExpiredStateCannotBeUpdated
  Recommendation_Error_52511: {
    hasLearnMore: true,
    helpId: 'help:ext53094',
  }, // Recommendation_Error_Keyword_AdGroupInExpiredStateCannotBeUpdated
  Recommendation_Error_52512: {
    hasLearnMore: true,
    helpId: 'help:ext53094',
  }, // Recommendation_Error_AdGroupIdInvalid
  Recommendation_Error_51501: {
    hasLearnMore: true,
    helpId: 'help:ext60029',
  }, // Recommendation_Error_CampaignIdInvalid
  Recommendation_Error_93001: {
    hasLearnMore: true,
    helpId: 'help:ext60029',
  }, // Recommendation_Error_NegativeKeywordDeleted
  Recommendation_Error_93114: {
    hasLearnMore: true,
    helpId: 'help:ext60029',
  }, // Recommendation_Error_SharedListDeleted
  Recommendation_Error_7: {
    hasLearnMore: true,
    helpId: 'help:ext60029',
  }, // Recommendation_Error_Generic_OpportunityExpired
  Recommendation_Error_1010: {
    hasLearnMore: true,
    helpId: 'help:ext53092',
  }, // Recommendation_Error_Bid_InvalidPeroidToUpdate
  Recommendation_Error_21000: {
    hasLearnMore: false,
    helpId: null,
  }, // Recommendation_Error_Generic_SystemFailed
  Recommendation_Error_1001519: {
    hasLearnMore: true,
    helpId: 'help:ext53097',
  }, // Recommendation_Error_MaxKeywordsLimitExceededForAdGroup
  Recommendation_Error_1001518: {
    hasLearnMore: true,
    helpId: 'help:ext51042',
  }, // Recommendation_Error_MaxKeywordsLimitExceededForAccount
  Recommendation_Error_1001515: {
    hasLearnMore: true,
    helpId: 'help:ext53092',
  }, // Recommendation_Error_KeywordBroadBidAmountsLessThanFloorPrice
  Recommendation_Error_1001516: {
    hasLearnMore: true,
    helpId: 'help:ext53092',
  }, // Recommendation_Error_KeywordBroadBidAmountsGreaterThanCeilingPrice
  Recommendation_Error_1001531: {
    hasLearnMore: false,
    helpId: null,
  }, // Recommendation_Error_Keyword_KeywordNotFound
  Recommendation_Error_1001215: {
    hasLearnMore: true,
    helpId: 'help:ext53094',
  }, // Recommendation_Error_Keyword_AdGroupInExpiredStateCannotBeUpdated
  Recommendation_Error_1001231: {
    hasLearnMore: true,
    helpId: 'help:ext53094',
  }, // Recommendation_Error_Keyword_AdGroupInExpiredStateCannotBeUpdated
  Recommendation_Error_1001201: {
    hasLearnMore: true,
    helpId: 'help:ext53094',
  }, // Recommendation_Error_AdGroupIdInvalid
  Recommendation_Error_1001100: {
    hasLearnMore: true,
    helpId: 'help:ext60029',
  }, // Recommendation_Error_CampaignIdInvalid
  Recommendation_Error_1004329: {
    hasLearnMore: true,
    helpId: 'help:ext60029',
  }, // Recommendation_Error_NegativeKeywordDeleted
  Recommendation_Error_1004314: {
    hasLearnMore: true,
    helpId: 'help:ext60029',
  }, // Recommendation_Error_SharedListDeleted
  Recommendation_Error_93214: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_FailedToSaveWithDuplicatedName
  Recommendation_Error_93222: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goals_PleaseEnterValidGoalName
  Recommendation_Error_93223: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goals_PleaseEnterValidGoalName
  Recommendation_Error_93234: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_FailedToSaveWithLongUrl
  Recommendation_Error_93272: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_GoalTypeCannotBeChanged
  Recommendation_Error_93237: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_InvalidEventGoalCategory
  Recommendation_Error_93239: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_InvalidEventGoalAction
  Recommendation_Error_93271: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_GoalValueCurrencyCodeShouldNotBeNull
  Recommendation_Error_93274: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_Type_InStoreTransactionAlert
  Recommendation_Error_56028: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_AdvertiserCustomerIdInvalid
  Recommendation_Error_93233: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_FailedToSaveWithInvalidURLCharacters
  Recommendation_Error_93277: {
    hasLearnMore: false,
    helpId: null,
  }, // UnifiedEventTracking_Goal_Creation_CustomerNotEligibleForConversionGoalSelection
};

export const CONTEXTUAL_DELIVERY_STATUS = [
  'InvalidFinancialStatusOther',
  'CampaignSuspended',
  'CampaignBudgetPaused',
  'CampaignUserPaused',
  'Eligible',
  'BudgetSuggestions',
  'AutoBiddingLimitedByNotEnoughConversions',
  'AutoBiddingLearning',
  'AutoBiddingLimitedByNotEnoughRevenue',
  'NoEligibleAdGroups',
  'AdGroupExpired',
  'AdGroupDraft',
  'AdGroupUserPaused',
  'AdGroupPrivacyPending',
  'AdGroupTargetingTooNarrow',
  'NoEligibleAds',
  'NoEligibleKeywords',
  'InlineOpportunity',
  'New',
];

export const CONTEXTUAL_ENTITY_TYPE = {
  CAMPAIGN: 'Campaign',
  ADGROUP: 'AdGroup',
  KEYWORD: 'Keyword',
  AUDIENCE: 'Audience',
  NEGATIVE_KEYWORD_LIST: 'NegativeKeywordList',
  SHARED_BUDGET: 'SharedBudget',
  ACCOUNT: 'Account',
  GOAL: 'Goal',
  CURRENT_SETTING: 'CurrentSetting',
  SUGGESTED_SETTING: 'SuggestedSetting',
  GENERATED_FROM: 'GeneratedFrom',
  MORE_IMAGES: 'MoreImages',
  MORE_CONVERSION_CLARITY_BUTTONS: 'MoreConversionClarityButtons',
  IMPORTED_TASK_ITEM: 'ImportedTaskItem',
  CAMPAIGNS: 'Campaigns',
};

export const RECOMMENDATION_NOTIFICATION_REJECT_REASONS = {
  NotInterested: 30,
  OtherSolution: 60,
  DoNotUnderstand: 10,
  NotApplicable: 180,
  SpendNoMore: 10,
  UseOtherSolution: 60,
  ManualBidding: 60,
  NotAlignGoal: 30,
  NotImprovePerf: 30,
  Other: 10,
};

export const RECOMMENDATION_SOURCE_FOR_SORT_TYPES = {
  [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.KeywordOpportunitySummary/SourceForSort',
  [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.BroadMatchAdoptionOpportunitySummary/SourceForSort',
};

export const CROSS_LEVEL_TYPES = [
  RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD,
];

export const VIEW_TYPES = {
  SUMMARY: 'recommendation-summary',
  DETAILS: 'recommendation-details',
  HISTORY: 'recommendation-history',
  AUTO_APPLY_SETTINGS: 'recommendation-auto-apply-settings',
  AUTO_APPLY_BULK_UPLOAD: 'recommendation-auto-apply-bulk-upload',
};

export const CampaignType = {
  None: 0,
  Default: 0b1,
  Shopping: 0b10,
  DynamicSearchAds: 0b100,
  Audience: 0b1000,
  Smart: 0b10000,
  PerformanceMax: 0b1000000,
  All: 0xFFFF,
};

export const SUPPORTED_CAMPAIGN_TYPES = [
  CampaignType.Default,
  CampaignType.Shopping,
  CampaignType.DynamicSearchAds,
  CampaignType.Audience,
  CampaignType.PerformanceMax,
];

export const MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS = {
  Deficit: 'Deficit',
  Surplus: 'Surplus',
};

export const DOWNLOAD_SCOPE = {
  INDIVIDUAL: 'Individual',
  ALL: 'All',
};

export const TASK_STATUS = {
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  INPROGRESS: 'InProgress',
};

export const FAC_FEATURE_ID = {
  GOOGLE_IMPORT: '206',
  FACEBOOK_IMPORT: '207',
  CONVERSION_TRACKING: '208',
  CALLOUTCARD_GOOGLE_IMPORT: '209',
  CALLOUTCARD_PINTEREST_IMPORT: '210',
  CALLOUTCARD_FACEBOOK_IMPORT: '211',
  AUTO_BIDDING_MAX_CLICKS: '212',
  AUTO_BIDDING_MAX_CONVERSIONS: '213',
  SHOPPING_CAMPAIGN: '214',
};

export const PAGINATION_DIRECTION = {
  PREVIOUS_PAGE: 'previous_page',
  NEXT_PAGE: 'next_page',
  CURRENT_PAGE: 'current_page',
};

export const ORDERBY_DIRECTION = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC',
};

export const FILTERBY = {
  UNDEFINED: 'Undefined',
  GREATER_THAN: 'GreaterThan',
  GREATER_EQUAL: 'GreaterEqual',
  LESS_THAN: 'LessThan',
  LESS_EQUAL: 'LessEqual',
};

export const PAGINATION_ORDERBY = {
  DEFAULT: 'Default',
};

// mapping of FeatureId to RECOMMENDATION_TYPES, sorted by priority, and string keys
export const FAC_RECOMMENDATION_CONFIG = {
  [FAC_FEATURE_ID.GOOGLE_IMPORT]: {
    couponTitleActionKey: 'Summary_Card_Coupon_Title_Google_Import',
    couponDescriptionTitleKey: 'Summary_Card_Coupon_Description_Title_Google_Import',
    couponDescriptionKey: 'Summary_Card_Coupon_Description_Google_Import',
    couponTagMessageKey: 'Summary_Card_Coupon_Tag_Message_Google_Import',
    couponLightboxTitle: 'Coupon_LightboxTitleNew',
    priority: [
      RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED,
      RECOMMENDATION_TYPES.GOOGLE_IMPORT,
    ],
  },
  [FAC_FEATURE_ID.FACEBOOK_IMPORT]: {
    couponTitleActionKey: 'Summary_Card_Coupon_Title_Facebook_Import',
    couponDescriptionTitleKey: 'Summary_Card_Coupon_Description_Title_Facebook_Import',
    couponDescriptionKey: 'Summary_Card_Coupon_Description_Facebook_Import',
    couponTagMessageKey: 'Summary_Card_Coupon_Tag_Message_Facebook_Import',
    couponLightboxTitle: 'Coupon_LightboxTitleNew',
  },
  [FAC_FEATURE_ID.CONVERSION_TRACKING]: {
    couponTitleActionKey: 'Summary_Card_Coupon_Title_Conversion_Tracking',
    couponDescriptionTitleKey: 'Summary_Card_Coupon_Description_Title_Conversion_Tracking',
    couponDescriptionKey: 'Summary_Card_Coupon_Description_Conversion_Tracking',
    couponTagMessageKey: 'Summary_Card_Coupon_Tag_Message_Conversion_Tracking',
    couponLightboxTitle: 'Coupon_LightboxTitleNew',
    priority: [
      RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY,
      RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY,
      RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
      RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
    ],
  },
  [FAC_FEATURE_ID.SHOPPING_CAMPAIGN]: {
    couponTitleActionKey: 'Summary_Card_Coupon_Title_Shopping_Campaign',
    couponDescriptionTitleKey: 'Summary_Card_Coupon_Description_Title_Shopping_Campaign',
    couponDescriptionKey: 'Summary_Card_Coupon_Description_Shopping_Campaign',
    couponTagMessageKey: 'Summary_Card_Coupon_Tag_Message_Shopping_Campaign',
    couponLightboxTitle: 'Coupon_LightboxTitleNew_Shopping_Campaign',
  },
};

// creates array mapping RECOMMENDATION_TYPES to FeatureId
export const FAC_RECOMENDATIONTYPE_FEATUREID_MAPPING = _.reduce(
  FAC_RECOMMENDATION_CONFIG,
  (mapping, { priority }, featureId) =>
    _.extend(mapping, ..._.map(priority, recType => ({ [recType]: featureId }))),
  {}
);

export const TYPE_DESCRIPTION_TABLE = {
  [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: 'Recommendation_Type_Name_Reallocate_Budget_Opportunity',
};

export const DATE_FILTER = {
  LAST_90: 'last90Days',
  LAST_180: 'last180Days',
};

export const FILTER_TO_TIME = {
  [DATE_FILTER.LAST_90]: -90,
  [DATE_FILTER.LAST_180]: -180,
};

export const schema = {
  scenario: [
    {
      name: 'loadRecommendationTab',
      value: 'LoadRecommendationTab',
      setting: {},
      activity: [
        {
          name: 'loadRecommendationTab',
          value: 'LoadRecommendationTab',
        },
        // Below activities are for performance logs.
        {
          name: 'getSummary',
          value: 'getsummary',
        },
        {
          name: 'getCoupons',
          value: 'getCoupons',
        },
        {
          name: 'getHistory',
          value: 'getHistory',
        },
        {
          name: 'getCount',
          value: 'getCount',
        },
        {
          name: 'track',
          value: 'track',
        },
        {
          name: 'viewCategory',
          value: 'ViewCategory',
        },
      ],
    },
  ],
};

export const GOAL_OPERATOR_TYPES_STRING_VALUES = {
  EqualTo: 'UnifiedEventTracking_Goal_Creation_Type_Option_EqualsTo',
  EqualsTo: 'UnifiedEventTracking_Goal_Creation_Type_Option_EqualsTo',
  Contains: 'UnifiedEventTracking_Goal_Creation_Type_Option_Contains',
  BeginsWith: 'UnifiedEventTracking_Goal_Creation_Type_Option_BeginsWith',
  RegularExpression: 'UnifiedEventTracking_Goal_Creation_Type_Option_RegularExpression',
  LessThan: 'UnifiedEventTracking_Goal_Creation_Type_Option_LessThan',
  GreaterThan: 'UnifiedEventTracking_Goal_Creation_Type_Option_GreaterThan',
};

export const ADGROUP_TYPES = {
  SearchStandard: 'SearchStandard',
  SearchDynamic: 'SearchDynamic',
};

export const AUTO_APPLY_TYPES = {
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: 'ResponsiveSearchAdsAutoApply',
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: 'MultimediaAdsAutoApply',
};

export const AUTO_APPLY_TYPES_NAMES = {
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: 'responsive search ads',
};

// Recommendation types which support AdInsight MT new auto apply pipeline
export const SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES = [
  RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
  RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD,
  RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
  RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS,
];

export const HISTORY_PAGE_TAB_TYPES = {
  ALL: 'All',
  MANUAL: 'Manual',
  AUTO: 'Auto',
};

export const IMPORT_TYPE = {
  GOOGLE: 'googleimport',
  FACEBOOK: 'facebookimport',
};

export const ISSUE_TYPES = {
  1: 'Destination URL',
  2: 'Event',
  3: 'Scope',
  4: 'Revenue value',
  5: 'UET',
};

export const GA_NO_PILOTING_TYPES = [
  RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REALLOCATE_BUDGET,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.FACEBOOK_IMPORT,
  RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
  RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
  RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD,
  RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS,
  RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD,
  RECOMMENDATION_TYPES.REPAIR_KEYWORD,
  RECOMMENDATION_TYPES.REPAIR_ADS,
  RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.CALLOUT,
  RECOMMENDATION_TYPES.SITE_LINK,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT,
  RECOMMENDATION_TYPES.TRENDING_QUERY,
  RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY,
  RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER,
  RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.FIX_AD_DESTINATION,
  RECOMMENDATION_TYPES.FIX_AD_TEXT,
];

export const MCC_NOT_SUPPORTED_TYPE = [
  RECOMMENDATION_TYPES.FIX_AD_DESTINATION,
  RECOMMENDATION_TYPES.FIX_AD_TEXT,
  RECOMMENDATION_TYPES.IMAGE_EXTENSION,
];

export const CAMPAIGN_ODATA_ERROR_BASELINE = 1000000;

export const INLIE_APPLY_ERROR_SUPPORT_TYPES = [
  RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
];

export const MCC_ACCOUNTS_CAPPING = 100;

export const COMPETITION_SUMMARY_TOP_NUMBER = 4;

export const RECOMMENDATION_SUMMARY_TOP_NUMBER = 10;

export const isFilterSearchStandardAdgroupRecommendationType = recommendationType =>
  recommendationType === RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY ||
  recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD ||
  recommendationType === RECOMMENDATION_TYPES.TRENDING_QUERY;

export const RECOMMENDATION_AUTO_APPLY_SETTINGS_TOOLTIPS = {
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: {
    text: _TL_('We created a new recommendation to improve conversion tracking and conversion goal settings.'),
    helpText: _TL_('Learn more about conversion tracking.'),
  },
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: {
    text: _TL_('We recommend you set up values for missing keyword parameters. Making these changes can increase the click-through rates and ad impressions of your ads.'),
    helpText: _TL_('Learn more about missing keyword parameters.'),
  },
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: {
    text: _TL_('We created a new recommendation to increase conversions and improve conversion tracking when using an enabled UET tag.'),
    helpText: _TL_('Learn more about conversion tracking.'),
  },
  [RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD]: {
    text: _TL_('We created a new recommendation to help you resolve negative keyword conflicts that prevent your ads from displaying.'),
    helpText: _TL_('Learn more about negative keyword conflicts.'),
  },
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: {
    text: _TL_('We created a new recommendation to improve your campaign performance by adding multimedia search ads to your ad groups.'),
    helpText: _TL_('Learn more about adding multimedia search ads.'),
  },
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: {
    text: _TL_('We created a new recommendation to improve your campaign performance by adding responsive search ads to your ad groups.'),
    helpText: _TL_('Learn more about responsive search ads.'),
  },
};

export const TOP_POSITION_RECOMMENDATION_TYPES = [
  RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION,
];
